import { configureStore } from '@reduxjs/toolkit'
import authReducer, { tokensSynced, logout } from './authSlice'
import { baseApi } from './api/baseApi'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        [baseApi.reducerPath]: baseApi.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware)
})

// Mantiene sincronizadas todas las pestañas del mismo navegador: si una pestaña
// renueva el token o cierra sesión, el resto lo reflejan sin esperar a su propio 401
// (evita que una pestaña con el refresh token ya rotado por otra dispare la
// detección de reutilización del backend, que revocaría todas las sesiones del usuario)
if (typeof window !== 'undefined') {
    window.addEventListener('storage', (event) => {
        if (event.key !== 'token' && event.key !== 'refreshToken') return

        const token = localStorage.getItem('token')
        const refreshToken = localStorage.getItem('refreshToken')

        if (!token || !refreshToken) {
            store.dispatch(logout())
        } else if (token !== store.getState().auth.token) {
            store.dispatch(tokensSynced({ token, refreshToken }))
        }
    })
}

